// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Tooltip = require("../../reason/common/Tooltip.bs.js");
var Icon__Jsx3 = require("../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var IsTouchDevice = require("is-touch-device");
var JsxRuntime = require("react/jsx-runtime");
var Theme__Color__Vars = require("../../reason/common/Theme/Theme__Color__Vars.bs.js");
var VisuallyHidden = require("@reach/visually-hidden").default;

var isTouch = IsTouchDevice();

function SearchPagesSharedComponents$HelperIcon(props) {
  var label = props.label;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(VisuallyHidden, {
                      children: label
                    }),
                isTouch ? null : JsxRuntime.jsx("span", {
                        children: JsxRuntime.jsx(Tooltip.make, {
                              label: label,
                              children: JsxRuntime.jsx("span", {
                                    children: JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                                icon: props.icon,
                                                size: 16,
                                                color: Theme__Color__Vars.gray
                                              }),
                                          className: "flex items-center"
                                        })
                                  })
                            }),
                        "aria-hidden": true
                      })
              ]
            });
}

var HelperIcon = {
  isTouch: isTouch,
  make: SearchPagesSharedComponents$HelperIcon
};

function SearchPagesSharedComponents$NoMatches(props) {
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("h3", {
                    children: props.text,
                    className: "text-2xl font-medium leading-8 text-gray-700 text-center"
                  }),
              className: "flex flex-col items-center justify-center mx-auto max-w-[500px] min-h-[200px]"
            });
}

var NoMatches = {
  make: SearchPagesSharedComponents$NoMatches
};

function SearchPagesSharedComponents$ResultsInfo(props) {
  var helperIconText = props.helperIconText;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: props.text,
                      className: "text-gray-600"
                    }),
                helperIconText !== undefined ? JsxRuntime.jsx(SearchPagesSharedComponents$HelperIcon, {
                        label: helperIconText,
                        icon: "Question"
                      }) : null
              ],
              className: "flex flex-row gap-2 items-center col-span-1 md:col-span-2 lg:col-span-3"
            });
}

var ResultsInfo = {
  make: SearchPagesSharedComponents$ResultsInfo
};

exports.HelperIcon = HelperIcon;
exports.NoMatches = NoMatches;
exports.ResultsInfo = ResultsInfo;
/* isTouch Not a pure module */
